import { ActionReducerMapBuilder, createAction } from '@reduxjs/toolkit';
import { getVehicleGeofenceReport } from '../services/vehicleGeofence';
import { formatVehicleGeofenceReportItem } from '../utils/helpers';
import { VehicleGeofenceReportSlice } from '../types';
import { ReportsSlice, ReportType } from '../../../types';

export const vehicleGeofenceInitialState: VehicleGeofenceReportSlice = {
  isFailed: false,
  isLoading: false,
  transports: {},
};

export const resetState = createAction('vehicleGeofence/resetState');

export const vehicleGeofenceReducers = (
  builder: ActionReducerMapBuilder<ReportsSlice<VehicleGeofenceReportSlice>>,
) => {
  builder.addCase(getVehicleGeofenceReport.pending, (state) => {
    state[ReportType.GEOFENCES].isLoading = true;
  });

  builder.addCase(getVehicleGeofenceReport.fulfilled, (state, action) => {
    state[ReportType.GEOFENCES].isLoading = false;

    Object.entries(action.payload.transports).forEach(([key, value]) => {
      const items = value.items.map(formatVehicleGeofenceReportItem).flat();

      state[ReportType.GEOFENCES].transports[Number(key)] = {
        items,
      };
    });
  });

  builder.addCase(getVehicleGeofenceReport.rejected, (state) => {
    state[ReportType.GEOFENCES].isLoading = false;
    state[ReportType.GEOFENCES].isFailed = true;
  });

  builder.addCase(resetState, (state) => {
    state[ReportType.GEOFENCES] = vehicleGeofenceInitialState;
  });
};
